<template>
    <div class="home-bg">
        <home-header @handleSelect="handleSelect"></home-header>
        <swipe class="home-swipe" :autoplay="3000" indicator-color="white" @change="onSwiperChange">
            <template v-for="(item, index) in banner_list">
                <swipe-item :key="index">
                    <img class="banner-img" :src="item.img" alt="" @click="bannerClick(item)">
                </swipe-item>
            </template>
        </swipe>
        <div class="tabs-wrap">
            <tabs v-model="active" background="transparent" color="#1244f1" line-width="0.85rem" line-height="0.17rem"
                @change="tabsChange">
                <tab title="疾病检索">
                    <template #title>
                        <p class="tabs-title">科室检索</p>
                    </template>
                    <home-list ref="department" @word-more-click="wordMoreClick" :content_height="content_height" :sysusers_id="sysusers_id"
                        type="department" :words="words_list['department']" ></home-list>
                </tab>
                <tab title="疾病检索">
                    <template #title>
                        <p style="" class="tabs-title">疾病检索</p>
                    </template>
                    <home-list ref="disease" @word-more-click="wordMoreClick" :content_height="content_height"  :sysusers_id="sysusers_id"
                        type="disease" :words="words_list['disease']"></home-list>
                </tab>
            </tabs>
        </div>
        <action-sheet v-model="show_more_panel" :title="more_panel_title">
            <div class="more-words-panel">
                <div class="more-words-wrap">
                    <div v-for="(word, index) in words_list[current_type]" :key="index"
                        :class="['panel-word',index % 3 != 0 ? 'ml-3' : '',current_word[current_type][current_type+'_id'] == word[current_type+'_id'] ? 'panel-word-active' : '']"
                        @click="wordClick(word,index)">
                        <p class="panel-word-text">{{Utils.getReplaceString(word[current_type+'_name'],7)}}</p>
                    </div>
                </div>
            </div>
        </action-sheet>
    </div>
</template>

<script>
    import {
        Swipe,
        SwipeItem,
        Tab,
        Tabs,
        ActionSheet
    } from 'vant'
    import HomeList from '@/components/Home/HomeList'
    import HomeHeader from '@/components/Home/HomeHeader'
    import Request from '@request'
    import api from '@api'
    import Utils from '@/js/Utils'

    export default {
        name: 'Home',
        components: {
            Swipe,
            SwipeItem,
            Tab,
            Tabs,
            HomeList,
            HomeHeader,
            ActionSheet
        },
        data() {
            return {
                active: 0,
                sysusers_id: 0,
                show_more_panel: false,
                more_panel_title: '科室检索',
                words: ['全部', '心血管科', '呼吸科'],
                content_height: '',
                banner_list: [],
                words_list: {
                    department: [],
                    disease: []
                },
                current_type: 'department',
                current_word: {
                    department: {},
                    disease: {}
                },
                Utils
            }
        },
        mounted() {
            // this.getBaner()
            //     this.getDeptList()
            //     this.getDiseaseList()
            document.title = '医谱健康网'
            this.$nextTick(() => {
                const node = document.querySelector('.home-list-content')
                if (node) {
                    const body = document.querySelector('body')
                    this.content_height = body.getBoundingClientRect().height - node.getBoundingClientRect()
                        .top + 'px'
                }
            })
        },
        methods: {
            handleSelect(data) {
                this.sysusers_id = data.sysusers_id
                this.getBaner()
                this.getDeptList()
                this.getDiseaseList()
            },
            getBaner() {
                Request.post(api.home.banner, {
                    sysusers_id: this.sysusers_id || ''
                }).then(res => {
                    const {
                        data
                    } = res
                    this.banner_list = data
                })
            },
            bannerClick(item) {
                if (item.ads_link) location.href = item.ads_link
            },
            getDeptList() {
                Request.post(api.home.department_list, {
                    sysusers_id: this.sysusers_id
                }).then(res => {
                    const {
                        data
                    } = res
                    this.words_list.department = [{
                        department_id: 0,
                        department_name: '全部'
                    }, ...data]
                })
            },
            getDiseaseList() {
                Request.post(api.home.disease_list, {
                    sysusers_id: this.sysusers_id
                }).then(res => {
                    const {
                        data
                    } = res
                    this.words_list.disease = [{
                        disease_id: 0,
                        disease_name: '全部'
                    }, ...data]
                })
            },

            wordMoreClick(data) {
                const {
                    type,
                    word
                } = data
                this.current_type = type
                this.current_word[type] = word
                this.more_panel_title = type == 'department' ? '科室检索' : '疾病检索'
                this.show_more_panel = true
            },
            wordClick(word, index) {
                const {
                    disease_id = 0, department_id = 0
                } = word
                
                this.current_word[this.current_type] = word
                this.$refs[this.current_type].getData(word, {
                    department_id,
                    disease_id
                }, index)
                this.show_more_panel = false
            },
            onSwiperChange(index) {

            },
            tabsChange() {

            }
        }
    }
</script>

<style>
    .home-bg .home-swipe {
        width: 93.44%;
        margin: 0 auto;
        height: 5.5rem;
        
        box-shadow: 0rem 0.13rem 0.38rem 0rem rgba(190, 190, 190, 0.6);
        border-radius: 0.21rem;
        position: relative;
    }

    .home-bg .van-swipe__indicators {
        left: inherit;
        right: 1rem;
    }

    .home-bg .van-tab {
        flex: none;
        line-height: normal;
    }

    .home-bg .home-swipe .van-swipe-item {
        width: 100%;
        color: #fff;
        height: 5.5rem;
        text-align: center;
        background-color: #39a9ed;
    }

    .home-bg .van-action-sheet__header {
        font-weight: bold;
        font-size: 0.73rem;
        color: #222222;
    }

    .home-bg .van-action-sheet__close {
        color: black;
        font-size: 1rem;
    }
    .home-bg .van-tabs__nav {
        width: 100%;
        /* padding: 0 3.33%; */
        /* box-sizing: border-box; */
        padding-left: 3.33%;
        background: #fff !important;
    }
    /* 调节跟父组件宽度一致 */
    @media screen and (min-width: 581px) {
        .home-bg .van-tabs__wrap {
            height: 64px !important;
        }

        .home-bg .van-popup--bottom {
            margin-left: 0;
            max-width: 580px;
            width: 100%;
            left: auto;
            bottom: 0;
            overflow-x: hidden;
        }

        .home-bg .van-action-sheet__header {
            line-height: 68px;
        }
    }

    .home-bg .van-tab:nth-child(2) {
        margin-left: 0.5rem;
    }
</style>
<style scoped>
    .home-bg {
        /* margin: 0.5rem 3.33% 0 3.33%; */
        /* display: flex;
        flex-direction: column;
        align-items: center; */
        height: 100%;
        background-color: #fff;
    }

    .tabs-wrap {
        align-self: start;
        margin-top: 0.75rem;
        flex: 1;
        overflow: hidden;
        width: 100%;
        height: 100%;
        margin: 0.5rem auto;
        background: #f4f4f4;
    }

    .tabs-title {
        width: 3rem;
        font-size: 0.73rem;
        font-weight: bold;
        color: #222222;
    }

    .more-words-panel {
        width: 100%;
        height: 18.67rem;
        overflow-y: auto;
        padding: 0 0 0.5rem 0;
    }

    .more-words-wrap {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-left: 5%;
        margin-right: 5%;
        /* width: 100%; */
    }

    .panel-word {
        margin-top: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30%;
        height: 1.2rem;
        background-color: #f4f4f4;
        border-radius: 0.6rem;
        cursor: pointer;
    }

    .panel-word-active {
        background-color: #dbe3ff;
    }

    .panel-word-text {
        font-size: 0.6rem;
        color: #888888;
    }

    .panel-word-active .panel-word-text {
        color: #1244f1;
    }

    .ml-3 {
        margin-left: 5%;
    }

    .banner-img {
        height: 5.5rem;
        width: 100%;
    }
</style>